import React from 'react';
import '../App.js';
import { createEndPoint, ENDPOINTS } from '../apis/Api';
import { useNavigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth.js';
import { useEffect } from 'react';
import useAxiosPrivate from '../hooks/useAxiosPrivate';

const CREATEPOST_URL = 'api/Post/';

function CreatePost() {       
    const [title, setTitle] = React.useState('');
    const [content, setContent] = React.useState('');
    const [creationDate, setCreationDate] = React.useState(new Date());
    const [author, setAuthor] = React.useState('');

    const axiosPrivate = useAxiosPrivate();

    const tagsInitial = ['frontend',
        'backend',
        'security',
        'react',
        'csharp'
    ];

    const [tags, setTags] = React.useState(tagsInitial);

    var description = '';

    const navigate = useNavigate();
    const { auth } = useAuth();

    // set errors
    const [errors, setErrors] = React.useState({});

    // max. character for a single post
    const maxCharacters = 100000;
    const charactersLeft = Math.max(0, maxCharacters - content.length);

    useEffect(() => {
        const getUserData = async () => {            
            try {
                // setting data
                setAuthor(auth.username);
            } catch (err) {
                console.log(err);
            }
        }
        
        getUserData();
    }, [auth.username]);

    const handleSubmit = async (e) => {
        // prevent default behavior of the form (prevent reloading)
        e.preventDefault();
        setErrors({});

        var descriptionSize = 200;

        for (var i=0; i < content.length; i++)
        {
            description += content[i];
            if (descriptionSize === i)
            {
                description += ' [...]';
                break;
            }
        }

        if (!validate()) {
            return;
        }

        var now = new Date();
        console.log('NOW: ' + now);

        const data = {
            title: title,
            content: content,
            description: description,
            creationDate: now.toISOString(),
            author: author,
            tags: tags
        };
    
        console.log('Sending data:', data);

        try {
            const res = await axiosPrivate.post(
                CREATEPOST_URL,
                data,
                {
                    headers: { 'Content-Type': 'application/json' }
                }
            );

            console.log('Post created successfully!', res.data);
            navigate('/blog');
                
        } catch(err) {
            console.log('Error creating a post: ', err);
            console.log('Error response:', err.response?.data);

            if (err.response?.status === 401) {
                console.log('Unauthorized - token might have expired.');
                navigate('/login');
            } else if (err.response?.status === 403) {
                console.log('Forbidden - insufficient permissions.');
                navigate('/unauthorized');
            } else if (err.response?.status === 400) {
                console.log('Bad Request - validation error:', err.response?.data);
                setErrors({ 
                    server: `Failed to create post: ${JSON.stringify(err.response?.data?.errors || err.response?.data || 'Validation error')}` 
                });
            } else {
                setErrors({ server: 'Failed to create post. Please try again.' });
            }
        }
    }

    const validate = () => {
        var errors = {};

        // title validation
        errors.title = title !== '' ? '' : 'Type in a title of the post!';

        // content validation
        errors.content = content !== '' ? '' : 'Type in the content of the post!';

        // tags validation
        errors.tags = tags.length > 0 ? '' : 'At least one tag is required!';

        setErrors(errors);

        return Object.values(errors).every(item => item === '');
    }

    function deleteTag(index) {
        setTags(tags.filter((e, i) => i !== index))
    }

    return (
        <div className='post-create'>
            <h1 className='mt-5'>Create Post</h1>
            <form onSubmit={handleSubmit}>
                {errors.server && <div className='alert alert-danger'>{errors.server}</div>}
                <div className='post-form'>
                    <div className='post-tags'>
                        <span className='post-tag'>
                            Tags:
                        </span>
                        {
                            tags.map((tag, index) => (
                                <div className={'post-tag' + ' ' + 'tag-' + tag} key={index}>
                                    <span>#{tag}</span>
                                    <span>&nbsp;</span>
                                    <span className='close' onClick={() => deleteTag(index)}>&times;</span>    
                                </div>
                            ))
                        }
                    </div>
                    {errors.tags && <div className='error-text'>{errors.tags}</div>}
                    <label className='post-label'>
                        Post title:
                    </label>
                    <input 
                        type='text' 
                        className='form-control mb-2 ms-2' 
                        placeholder='Title' 
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        maxLength={500} 
                    />
                    {errors.title && <div className='error-text'>{errors.title}</div>}
                    <label className='post-label'>
                        Text:
                    </label>
                    <textarea 
                        className='form-control mb-2 ms-2' 
                        rows='10' 
                        placeholder='Your text...' 
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        maxLength={ maxCharacters }  
                    />
                    <div className='character-count'>
                        <p>Characters left: { charactersLeft }</p>
                    </div>
                    {errors.content && <div className='error-text'>{errors.content}</div>}
                </div>
                <button type='submit' className='btn btn-outline-dark me-2'>Save</button>
            </form>
        </div>
    )
};

export default CreatePost;